<template>
  <div>
  <div class="photo primary" @click="lightboxEffect(0)" :style="{ 'background-image': 'url(' + highlightPhoto.url + ')' }">
    <img :src="highlightPhoto.url" />
  </div>

    <div class="run-gallery">

      <div v-for="(thumbnail, index) in thumbnailsSorted" :key="index" class="run-img">
        <template>
        <img
            v-lazy="thumbnail.url"
            @click="lightboxEffect(index)"
            :class="'idx-'+index"
            class="light-box__thumbnail">
        </template>
      </div>
      <transition name="fade" mode="out-in">
        <div class="light-box__bg" v-if="bg">
          <div v-if="bg" class="light-box-container" tabindex="0" @keydown.esc="close">
            <div class="light-box__close" @click.stop="close"><img src="/images/lightbox/times-solid.svg"
                                                                      class="lb-action"></div>
            <p class="light-box__count" v-if="count">
              {{ currentImage + 1 }}/
              <span>{{ thumbnailsSorted.length }}</span>
            </p>
            <div @click="prev" class="light-box__prev light-box__btn"><img src="/images/lightbox/angle-left-solid.svg"
                                                                           class="lb-action"></div>

            <div v-if="bg" class="light-box__container">
              <transition name="fade" mode="out-in">
                <img
                    :key="largeImagesSorted[currentImage].unique_id"
                    :src="largeImagesSorted[currentImage].url"
                    class="light-box__container__img"
                >
              </transition>
            </div>

            <div class="light-box__caption" v-if="caption">
              <p v-if="captions[currentImage]">{{ captions[currentImage] }}</p>
            </div>

            <div @click="next" class="light-box__next light-box__btn"><img src="/images/lightbox/angle-right-solid.svg"
                                                                           class="lb-action"></div>
          </div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: false,
      currentImage: 0,
      count: true,
      caption: true
    };
  },
  props: {
    thumbnails: {
      type: Array,
      required: true
    },
    largeImages: {
      type: Array,
      required: true
    },
    captions: {
      type: Array,
      required: true
    },
    thumbnailsPath: {
      type: String,
      required: true
    },
    largePath: {
      type: String,
      required: true
    }
  },
  computed: {
    thumbnailsSorted() {
      let listCopy = this.thumbnails.filter((t) => !t.def).slice();
      return listCopy.length === 1 ? [] : listCopy;
    },
    highlightPhoto() {
      //let listCopy = this.thumbnails.filter((t) => t.def).slice()
      let defaulPos = this.thumbnails.map(function(e) { return e.def; }).indexOf(true);
      return this.thumbnails[defaulPos !== -1 ? defaulPos : 0];
    },
    largeImagesSorted() {
      let defaulPos = this.largeImages.map(function(e) { return e.default_photo; }).indexOf(true);
      let listCopy = this.largeImages.slice()
      this.moveToFront(listCopy, 0, defaulPos);
      return listCopy;

    }
  },
  mounted() {
    let $vm = this;

    window.addEventListener("keyup", function (event) {
      if (event.defaultPrevented) {
        return; // Should do nothing if the default action has been cancelled
      }
      let handled = false;
      if (event.key !== undefined && $vm.bg) {
        // Handle the event with KeyboardEvent.key and set handled true.
        if (event.key === 'Escape') {
          $vm.close();
          handled = true;
        }
        else if (event.key === 'ArrowLeft') {
          $vm.prev();
          handled = true;
        }
        else if (event.key === 'ArrowRight') {
          $vm.next();
          handled = true;
        }
      }

      if (handled) {
        // Suppress "double action" if event handled
        event.preventDefault();
      }
    }, true);
  },
  methods: {
    lightboxEffect(curr) {
      this.currentImage = curr;
      this.bg = !this.bg;
      document.getElementById("page-body").className = 'modal-open';
    },
    moveToFront(arr, new_index, old_index) {
      return arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    },
    next() {
      if (this.currentImage < this.largeImages.length - 1) {
        this.currentImage++;
      } else {
        this.currentImage = 0;
      }
    },
    prev() {
      if (this.currentImage > 0) {
        this.currentImage--;
      } else {
        this.currentImage = this.largeImages.length - 1;
      }
    },
    close() {
      this.bg = !this.bg;
      document.getElementById("page-body").className = '';
    }
  }
};
</script>

<style lang="scss">
body.modal-open {
  height: 100vh;
  overflow-y: hidden;
}
.lb-action {
  width: 40px;
  height: 40px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.light-box-container {
  position: relative;
  height: 100vh;
  width: 100vw;
}
.light-box {
  &__bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    //right: 0;
    //bottom: 0;
    background-color: rgba(0, 0, 0, 0.89);
    z-index: 1000;
  }

  &__thumbnail {
    cursor: pointer;
    //min-width: 94px;
    //min-height: 70px;
  }

  &__close {
    padding: 10px;
    position: absolute;
    right: 20px;
    top: 20px;
    background-image: url(/img/lightbox/close.svg);
    background-size: contain;
    background-position: center;
  }
  &__container {
    position: absolute;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 900px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-height: 800px;
    img {
      align-self: center;
      max-width: 100vw;
      max-height: 100vh;
    }
  }
  &__btn {
    background-size: contain;
    background-position: center;
    align-self: center;
    padding: 15px;
  }

  &__close,
  &__btn {
    cursor: pointer;
  }

  &__close,
  &__btn,
  &__caption,
  &__count {
    position: absolute;
    z-index: 3000;
    -webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
  filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, 0.5));
  }

  &__next {
    right: 20px;
  }
  &__prev {
    left: 20px;
  }
  &__next,
  &__prev {
    top: 50%;
    transform: translateY(-50%);
  }

  &__caption {
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 20px;
    justify-content: center;
  }

  &__count {
    left: 20px;
    font-size: 16px;
    color: #fff;
    top: 14px;
    padding: 0;
    margin: 0;
  }
}
</style>
